import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateMerckFonts: CreatomateFont[] = [
  {
    family: "Invention App Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-app-regular.ttf"
  },
  {
    family: "Invention App Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-app-light.ttf"
  },
  {
    family: "Invention Japanese Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-bold.ttf"
  },
  {
    family: "Invention Japanese Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-light.ttf"
  },
  {
    family: "Invention Japanese Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-regular.ttf"
  },
  {
    family: "Invention Latin Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-bold.ttf"
  },
  {
    family: "Invention Latin Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-light.ttf"
  },
  {
    family: "Invention Latin Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-regular.ttf"
  }
];

export const BuiltInMerckFonts: BuiltInFontDefinition[] = [
  {
    family: "Invention App",
    weights: [400, 700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-app-regular.ttf"
  },
  {
    family: "Invention App Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-app-light.ttf"
  },
  {
    family: "Invention Japanese Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-bold.ttf"
  },
  {
    family: "Invention Japanese Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-light.ttf"
  },
  {
    family: "Invention Japanese Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-japanese-regular.ttf"
  },
  {
    family: "Invention Latin Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-bold.ttf"
  },
  {
    family: "Invention Latin Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-light.ttf"
  },
  {
    family: "Invention Latin Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Merck/merck-invention-latin-regular.ttf"
  }
];
